
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Iit7Y291bnQsIG51bWJlciwgOjpjb21wYWN0LXNob3J0fSJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Ilsre2NvdW50LCBudW1iZXIsIDo6Y29tcGFjdC1zaG9ydH1dIn0=!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyIre2NvdW50fSI6Ilsre2NvdW50LCBudW1iZXIsIDo6Y29tcGFjdC1zaG9ydH1dIn0=!"
        )
      )
      });
  
      export { translations as default };
    